"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genLinkOrText = void 0;
var genLinkOrText = function (value, cb, options) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    if (cb === void 0) { cb = undefined; }
    if (options === void 0) { options = {}; }
    if ((!value.data ||
        !value.data._id ||
        (!((_a = value.data.meta) === null || _a === void 0 ? void 0 : _a.content_type) &&
            !((_b = value.data.meta) === null || _b === void 0 ? void 0 : _b.profile_type) &&
            !((_c = value.data) === null || _c === void 0 ? void 0 : _c.profileType) /**from the user data object */)) && !value.tagId && ['userTags', 'contentTags'].indexOf(value.tagCategory) === -1 // AND its not even a tag v3 type of data then...
    ) {
        return cb ? cb(value.display) : { link: undefined };
    }
    else {
        var link = "";
        // create links for content types
        if ((_e = (_d = value.data) === null || _d === void 0 ? void 0 : _d.meta) === null || _e === void 0 ? void 0 : _e.content_type) {
            var _k = value.data, content_type = _k.meta.content_type, _id = _k._id;
            link = "/published-page/".concat(content_type, "?id=").concat(_id);
        }
        // create links for profiles 
        else if (((_g = (_f = value.data) === null || _f === void 0 ? void 0 : _f.meta) === null || _g === void 0 ? void 0 : _g.profile_type) || ((_h = value.data) === null || _h === void 0 ? void 0 : _h.profileType)) {
            var profileType = ((_j = value.data.meta) === null || _j === void 0 ? void 0 : _j.profile_type) || value.data.profileType;
            var _l = value.data, user = _l.user, _id = _l._id;
            link = "/profile/userProfiles/".concat(profileType, "/").concat((user === null || user === void 0 ? void 0 : user._id) || _id);
        }
        // create links for tags
        else if (value.tagId &&
            value.tagCategory !== 'userTags' &&
            value.tagCategory !== 'contentTags') {
            //   link = `/tags/${value.tagType}/${value.tagId}`
            link = undefined; //temp hack, cuz we dont want to do redirects  to tag listing page (since old tagType implementation will be deprecated)
        }
        // create links for user tags
        else if (value.tagCategory === 'userTags') {
            link = "/profile/userProfiles/".concat(value.tagType || value.profileType, "/").concat(value._id);
        }
        //create links for content tags
        else if (value.tagCategory === 'contentTags') {
            //i think value.tagType is redundant, but will have to check
            link = "/published-page/".concat(value.tagType || value.meta.kp_content_type, "?id=").concat(value._id);
        }
        return cb ? (cb(value.display, link)) : ({ link: link });
    }
};
exports.genLinkOrText = genLinkOrText;
